import './App.css';
import { useEffect, useState } from 'react';
import logo from './figure/logo.png';
import mainImage from './figure/主图.png';
import wechatIcon from './figure/微信.png';
import phoneIcon from './figure/电话.png';
import emailIcon from './figure/邮箱.png';
import copyIcon from './figure/复制.png';
import qrCode from './figure/二维码.png';
import filingIcon from './figure/备案图标.png';
import { reportPageView, reportTrackingEvent } from './tracking';

function App() {
  const [showPhonePopup, setShowPhonePopup] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const phoneNumber = '15711512381';
  
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [copyEmailSuccess, setCopyEmailSuccess] = useState(false);
  const emailAddress = '15711512381@163.com';
  
  const [showWechatPopup, setShowWechatPopup] = useState(false);

  useEffect(() => {
    reportPageView();
  }, []);

  const handleDownloadClick = () => {
    reportTrackingEvent('download');
  };

  const handleCopyPhone = async () => {
    try {
      await navigator.clipboard.writeText(phoneNumber);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error('Failed to copy phone number:', err);
    }
  };

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(emailAddress);
      setCopyEmailSuccess(true);
      setTimeout(() => setCopyEmailSuccess(false), 2000);
    } catch (err) {
      console.error('Failed to copy email address:', err);
    }
  };

  return (
    <div className="tencent-security">
      {/* 导航栏 */}
      <header className="nav-header">
        <div className="nav-container">
          <div className="logo">
            <img src={logo} alt="续费藏挺深啊" />
            <span>续费藏挺深啊</span>
          </div>
          <div className="nav-right">
            <a href="/apk/app.apk" download className="pc-client" onClick={handleDownloadClick}>立即下载</a>
          </div>
        </div>
      </header>

      {/* 主横幅 */}
      <main className="main-banner">
        <div className="banner-container">
          <div className="banner-image">
            <img src={mainImage} alt="续费藏挺深啊" />
          </div>
          <div className="banner-content">
            <h1 className="banner-title">自动续费，一键扫描退订退款</h1>
            <p className="banner-subtitle">让每一笔自动续费，都在您明晰的掌控之中</p>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <a href="/apk/app.apk" download className="download-btn" onClick={handleDownloadClick}>立即下载</a>
              <div className="banner-icons">
                <div 
                  className="icon-item phone-icon-wrapper"
                  onMouseEnter={() => setShowWechatPopup(true)}
                  onMouseLeave={() => setShowWechatPopup(false)}
                >
                  <img 
                    src={wechatIcon} 
                    alt="微信" 
                    style={{ cursor: 'pointer' }}
                  />
                  {showWechatPopup && (
                    <div className="wechat-popup">
                      <div className="popup-arrow"></div>
                      <div className="wechat-popup-content">
                        <img src={qrCode} alt="微信二维码" className="qr-code-image" />
                      </div>
                    </div>
                  )}
                </div>
                <div 
                  className="icon-item phone-icon-wrapper"
                  onMouseEnter={() => setShowPhonePopup(true)}
                  onMouseLeave={() => setShowPhonePopup(false)}
                >
                  <img 
                    src={phoneIcon} 
                    alt="电话" 
                    style={{ cursor: 'pointer' }}
                  />
                  {showPhonePopup && (
                    <div className="phone-popup">
                      <div className="popup-arrow"></div>
                      <div className="popup-content">
                        <span className="phone-number">{phoneNumber}</span>
                        <button 
                          className="copy-btn" 
                          onClick={handleCopyPhone}
                          title={copySuccess ? '已复制' : '复制'}
                        >
                          <img src={copyIcon} alt={copySuccess ? '已复制' : '复制'} className="copy-icon" />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                <div 
                  className="icon-item phone-icon-wrapper"
                  onMouseEnter={() => setShowEmailPopup(true)}
                  onMouseLeave={() => setShowEmailPopup(false)}
                >
                  <img 
                    src={emailIcon} 
                    alt="邮箱" 
                    style={{ cursor: 'pointer' }}
                  />
                  {showEmailPopup && (
                    <div className="phone-popup">
                      <div className="popup-arrow"></div>
                      <div className="popup-content">
                        <span className="phone-number">{emailAddress}</span>
                        <button 
                          className="copy-btn" 
                          onClick={handleCopyEmail}
                          title={copyEmailSuccess ? '已复制' : '复制'}
                        >
                          <img src={copyIcon} alt={copyEmailSuccess ? '已复制' : '复制'} className="copy-icon" />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* 备案信息区域 */}
      <footer className="copy-right-area">
        <div className="copy-right-container">
          <span>
            Copyright © 2026 北京如凌科技有限公司  
            <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" style={{ marginLeft: '8px' }}>京ICP备2023015973号-7</a> 
            <img src={filingIcon} alt="备案图标" style={{ height: '19px', verticalAlign: 'middle', marginLeft: '8px', marginRight: '4px' }} />
            <a href="https://beian.mps.gov.cn/" rel="noreferrer" target="_blank">京公网安备11010502059168号</a>
          </span>
        </div>
      </footer>
    </div>
  );
}

export default App;
